
import { Vue, Prop, Component } from 'vue-property-decorator';
import { ITableFooterButton } from "@/types";
import SvgPlay from "@/assets/icons/play.svg";
import SvgPause from "@/assets/icons/pause.svg";
import SvgCancelLight from "@/assets/icons/cancel-light.svg";
import SvgCheckSmall from "@/assets/icons/check-small.svg";
import SvgLogout from "@/assets/icons/logout.svg";
import SvgTrashWhite from "@/assets/icons/trash-white.svg";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import BaseButton from "@/components-UI/BaseButton.vue";

enum FooterButtonsIcons {
    'play' = SvgPlay,
    'pause' = SvgPause,
    'cancel' = SvgCancelLight,
    'check' = SvgCheckSmall,
    'logout' = SvgLogout,
    'delete' = SvgTrashWhite,
}

@Component({
    components: { BaseButton, BaseTooltip },
})
export default class TableFooterButtons extends Vue {
    @Prop({ required: true }) buttons!: ITableFooterButton[];

    Icon = FooterButtonsIcons;

    isShowDisabledText(btn: ITableFooterButton): boolean {
        return btn.disabled! && !!btn.disabledText;
    }
}
